import React from 'react';
import styles from './Audio.module.scss';
import ContentAudio from '../../../content-audio/ContentAudio';
import FSBackIcon from 'src/assets/icons/arrow_back.svg?react';

type Props = {
  data: string;
  goBack?: () => void;
};

function MaterialAudio(props: Props) {
  const { data, goBack } = props;

  return (
    <div className={styles.wrapper}>
      <div className={styles.topBar}>
        <div className={styles.menuBar}>
          <button onClick={goBack} className={styles.closeButton} type={'button'}>
            <div className={styles.menuWrapper}>
            <FSBackIcon className={styles.closeIcon}/>
            </div>
          </button>
        </div>
      </div>
      <div className={styles.materialContent}>
        <ContentAudio data={data}/>
      </div>
    </div>
  );
}

export default MaterialAudio;
